/* eslint-disable no-undef */
const dev = {
  apiUrl: 'https://localhost:44320/'
};

const test = {
  apiUrl: 'https://qv9qq3u9kb.execute-api.us-west-2.amazonaws.com/Prod/'
};

const production = {
  apiUrl: 'https://vqrv1z9rga.execute-api.us-west-2.amazonaws.com/Prod/'
};

const config =
  process.env.REACT_APP_STAGE === 'dev'
    ? dev
    : process.env.REACT_APP_STAGE === 'test'
      ? test
      : production;

export default {
  ...config,
  validFileTypes: ['jpg', 'png', 'gif', 'jpeg', 'bmp', 'svg'],
  AddressMicroService:
  'https://ordenesapi.siadmin.com.mx/api/SucursalController/CodigoPostal_Buscar?Cp=',
  //'https://hk3o8njpki.execute-api.us-west-2.amazonaws.com/Prod/api/zip/BuscarCP?codigo=',
  SatMicroService:
  'https://9b15w7vfhb.execute-api.us-west-2.amazonaws.com/Prod/api/',
  reportingService: 'https://interaxis-reportes.jsreportonline.net/',
  RfcSatEmpleadoMicroService: 'https://wslib.taruks.com/api/'
};

export const reportCredentials =
  'c29wb3J0ZUBpbnRlcmF4aXMuY29tLm14OkludGVyQHhpcyEh';
